// extracted by mini-css-extract-plugin
export var body = "Article-module--body--X1rty";
export var icon = "Article-module--icon--MMEB-";